import ApiService from "@/core/services/api.service";

const OPERATION_PREVIEW_URL =
  "api-super-admin/customers/portfolio-summary/billing-operations/preview";
const OPERATION_APPLY_URL =
  "api-super-admin/customers/portfolio-summary/billing-operations/apply";

function extractPayload(response) {
  return response?.data?.data || response?.data || null;
}

export function previewBillingOperation(payload) {
  return ApiService.post(OPERATION_PREVIEW_URL, payload).then(extractPayload);
}

export function applyBillingOperation(payload) {
  return ApiService.post(OPERATION_APPLY_URL, payload).then(extractPayload);
}
